import {
  PortalUserResponse,
  PortalUserUpdateRequest,
} from '@b7hio/api-lib/src/ops-portal';
import { FeatureDialog, PortalType } from '@b7hio/core-lib/src';
import { superstructResolver, FormFriendly } from '@b7hio/core-lib/src/form';
import { omit } from '@b7hio/core-lib/src/utils';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import type { FieldValues, UseFormProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UserForm } from '../UserForm';
import {
  UpdateBankUserValidation,
  UpdateUserValidation,
} from '../UserForm/UserForm.validation';

interface Props {
  readonly user?: PortalUserResponse;
  readonly open?: boolean;
  readonly onClose: (event: object, reason: string) => void;
  readonly onSubmit: (values: PortalUserUpdateRequest) => Promise<void>;
  readonly portal: PortalType;
}

export const UserUpdateDialog = ({
  open,
  onClose,
  onSubmit,
  user: rawUser,
  portal,
}: Props): JSX.Element => {
  const { t } = useTranslation(['users']);
  const user = rawUser ? omit(rawUser, ['uid', 'partnerName', 'mfaMethods']) : undefined;

  return (
    <FeatureDialog
      id="UserUpdateDialog"
      open={open}
      title={t('users:updateUser')}
      onClose={onClose}>
      <Form<FormFriendly<PortalUserUpdateRequest>>
        defaultValues={user}
        resolver={superstructResolver(
          portal === 'ops' ? UpdateUserValidation : UpdateBankUserValidation,
          { coerce: true }
        )}
        onSubmit={onSubmit}>
        <UserForm isUpdating portal={portal} />
      </Form>
    </FeatureDialog>
  );
};

function Form<
  TFieldValues extends FieldValues = FieldValues,
  // eslint-disable-next-line @typescript-eslint/ban-types
  TContext extends object = object
>({
  children,
  onSubmit,
  ...props
}: UseFormProps<TFieldValues, TContext> & {
  readonly children: React.ReactNode;
  readonly onSubmit: (values: PortalUserUpdateRequest) => Promise<void>;
}) {
  const form = useForm(props);

  return (
    <FormProvider {...form}>
      <form
        style={{ gridArea: 'form' }}
        onSubmit={form.handleSubmit(onSubmit, (yeet) => {
          // eslint-disable-next-line no-console
          console.log(yeet);
        })}>
        {children}
      </form>
    </FormProvider>
  );
}
